// Copyright (c) 2016 Deere & Company

import MaintenancePlanClaimContainer from '../../claim/marketing/maintenance-plan/state-connector';

export default {
    component: MaintenancePlanClaimContainer,
    name: 'MARKETING_MAINTENANCE_PLAN',
    path: 'maintenance-plan/new(/:pin)'
};



// WEBPACK FOOTER //
// ./src/routes/claims/maintenance-plan-route.js